import { getBlueprintEditorPath } from "../../../../../../../router/RouterUtils";
import { Text, Link } from "@merge-api/merge-javascript-shared";
import CopyButton from "./CopyButton";

interface DiffTitleProps {
  integrationID: string;
  title: string;
  blueprintVersionID: string;
  // when provided, renders a copy button next to the title for copying this side's JSON
  copyText?: string;
  copyLabel?: string;
}

const DiffTitle = ({
  integrationID,
  title,
  blueprintVersionID,
  copyText,
  copyLabel,
}: DiffTitleProps) => {
  return (
    <div className="space-y-1 py-2 px-4 bg-[#FCFDFF]">
      <div className="flex items-center justify-between gap-x-2">
        <Text as="div" variant="h6">
          {title}
        </Text>
        {copyText !== undefined && (
          <CopyButton iconOnly text={copyText} label={copyLabel ?? `Copy ${title}`} />
        )}
      </div>
      <Link
        className="text-sm leading-[18px]"
        target="_blank"
        href={getBlueprintEditorPath(integrationID, blueprintVersionID)}
      >
        {blueprintVersionID}
      </Link>
    </div>
  );
};

export default DiffTitle;
